<template>
    <div>
        <v-combobox
            :value="selectedData"
            :items="data"
            :item-text="itemText"
            :item-value="itemValue"
            :multiple="multiple"
            :label="label"
            :chips="chips"
            :return-object="returnObject"
            deletable-chips
            dense
            @change="onChange"
            @input="inputChecked"
        >
        </v-combobox>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "ChipsCombobox",
    model: {
        prop: "selectedData",
        event: "update:selectedData",
    },

    props: {
        selectedData: {
            type: [Number, Array, Object],
            default: null,
        },
        data: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        chips: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        itemText: {
            type: String,
            required: "text",
        },
        itemValue: {
            type: String,
            required: "value",
        },
        returnObject: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        inputChecked(typeName) {
            if (_.isString(typeName)) {
                this.$emit("newType", typeName);
            }
        },

        onChange(newData) {
            console.log(newData);
            this.$emit("change", newData);
            this.$emit("update:selectedData", newData);
        },
    },
};
</script>
